module.exports = __webpack_public_path__ + "img/manage-data-1.acfc8002.jpg";